'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/object.values/polyfill.js
 ** module id = 500
 ** module chunks = 0
 **/